import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        selector: to.hash,
      };
    }

    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/szoftverfejlesztes',
      name: 'Development',
      component: loadView('Development'),
    },
    {
      path: '/marketing',
      name: 'Marketing',
      component: loadView('Marketing'),
    },
    {
      path: '/referenciak',
      name: 'References',
      component: loadView('References'),
    },
    {
      path: '/kapcsolat',
      name: 'Contact',
      component: loadView('Contact'),
    },
    {
      path: '/adatvedelmi-nyilatkozat',
      name: 'PrivacyStatement',
      component: loadView('PrivacyStatement'),
    },
    {
      path: '/jogi-nyilatkozat',
      name: 'LegalNotice',
      component: loadView('LegalNotice'),
    },
  ],
});
